import { applyOverrides } from '../../../shared';
import { rentCard as baseRentCard } from '../../shared';

export const rentCard = applyOverrides(baseRentCard, {
  fields: {
    totalRentAmount: {
      validation: [{ type: 'required', message: 'Required' }],
    },
  },
});
